module.exports = __webpack_public_path__ + "img/case25.56d842db.png";